import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQAccordion({ items, testIdPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((it, idx) => (
        <AccordionItem
          key={idx}
          value={`item-${idx}`}
          className="border-b border-black/10 last:border-b-0"
        >
          <AccordionTrigger
            data-testid={`${testIdPrefix}-q-${idx}`}
            className="text-left font-serif-display text-xl sm:text-2xl py-6 hover:no-underline"
          >
            {it.q}
          </AccordionTrigger>
          <AccordionContent
            data-testid={`${testIdPrefix}-a-${idx}`}
            className="text-base text-gray-700 leading-relaxed pb-6 pr-8"
          >
            {it.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
